import { ReactComponent as ArrowRightIcon } from "@/assets/arrow_right.svg";
import Clickable from "@/components/clickable";
// import { useCommonContext } from "@/utils/context/common";
import Track from "@/utils/track";
import { default as useNavigation } from "@/utils/useNavigate";
import { Exposable } from "@akc/mx-taro-h5-components";
import { default as React, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./ActivityMaterialList.module.less";

const ActivityMaterialList: React.FC<{ materialData: any; info: any; brandIds: any }> = (props) => {
    const track = Track();
    const [search] = useSearchParams();

    const { materialData, info, brandIds } = props;
    // const commonContext = useCommonContext();
    const { nav2RewardMaterialList, nav2RewardMaterialContent } = useNavigation();
    const listDom = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!listDom.current) {
            return;
        }
        listDom.current?.scrollTo(0, 0);
    }, [materialData]);

    const onItem = (material: any) => {
        track.track("resource_click", {
            page_name: "激励活动详情",
            previous_page_name: search.get("page_name"),
            domain: "激励活动",
            resource_type: "精选素材",
            resource_name: "精选素材",
            resource_content: "素材",
            page_code: search.get("actId"),
            resource_rank: 0,
            resource_id: search.get("actId"),
            btn_name: "查看素材",
            material_id: material.materialNo,
            material_name: material.materialContent,
        });
        nav2RewardMaterialContent({ material });
    };
    return (
        <>
            <div className={styles.materialList}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <div>精选素材</div>
                        <div className={styles.count}>({materialData.totalCount})</div>
                    </div>
                    <Clickable
                        className={styles.more}
                        onClick={() => nav2RewardMaterialList(info, brandIds)}
                        trackData={{
                            page_name: "激励活动详情",
                            resource_type: "精选素材",
                            btn_name: "更多素材",
                            resource_content: "素材",
                            page_code: search.get("actId"),
                        }}
                        trackContextKeys={[
                            "tab_name",
                            "tab_id",
                            "tab_rank",
                            "merchant_shop_code",
                            "activity_id",
                        ]}>
                        {materialData.totalCount > 4 && (
                            <>
                                <div>更多素材</div>
                                <ArrowRightIcon className={styles.icon} />
                            </>
                        )}
                    </Clickable>
                </div>
                <div ref={listDom} className={styles.list}>
                    {materialData.result.map((material, index) => (
                        <Exposable
                            key={index}
                            trackData={{
                                page_name: "激励活动详情",
                                resource_type: "素材",
                                resource_rank: index,
                                resource_content: "素材",
                                page_code: search.get("actId"),
                                material_id: material.materialNo,
                                material_name: material.materialContent,
                            }}
                            trackContextKeys={[
                                "tab_name",
                                "tab_id",
                                "tab_rank",
                                "merchant_shop_code",
                                "activity_id",
                            ]}
                            clickEventName="resource_click"
                        >
                            <div
                                className={`${styles.item} ${(materialData.result?.length ?? 0) === 1 ? styles.onlyOne : ""
                                    }`} onClick={() => onItem(material)}>
                                <div
                                    className={styles.img}
                                    style={{
                                        background: `url(${material.coverVOList?.[0]?.coverUrl}) 0% 0% / cover no-repeat`,
                                    }}>
                                    <div className={styles.count}>{material.imageCount}图</div>
                                </div>
                                <div className={styles.content}>
                                    <div className={styles.text}>
                                        {material.labelLocationVOList
                                            ?.filter(i => i.locationCode === "H5_MaterialList_MaterialTitlefront")
                                            .map((i, index) => (
                                                <img
                                                    className={styles.lable}
                                                    key={index}
                                                    src={i.labelInfoVOList?.[0].labelIconUrl}
                                                />
                                            ))}
                                        <span>{material.materialContent}</span>
                                    </div>
                                    {material.noteFlag === 1 && (
                                        <div className={styles.tagContainer}>
                                            <span className={styles.tag}>优质笔记</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Exposable>
                    ))}
                </div>
            </div >
        </>
    );
};

export default ActivityMaterialList;
